<script>

import { BLTyp, getAllBusinessLayer, updateBusinessLayerParent } from '@/model/dataLayer/api/Vip/BusinessLayer'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import GlobalConfig from '@/model/global/GlobalSettings'
import { VSelect } from 'vuetify/lib/components'

export default {
  name: 'OrganizationCard',
  components: { BaseForm },
  data () {
    return {
      editParentDialog: false,
      blList: [],
      parentList: [],
      parentInfo: {},
      childrenInfo: ''
    }
  },
  props: {
    info: {}
  },
  computed: {
    schema () {
      return [
        {
          key: 'parentId',
          name: 'parentId',
          component: VSelect,
          required: false,
          componentProps: {
            items: this.parentList.map(it => {
              it.text = it.name
              it.value = it.id
              return it
            }),
            itemValue: 'id',
            itemTitle: 'name'
          }
        }
      ]
    },
    QRCode () {
      return 'aaden:' + btoa('blId/' + GlobalConfig.blId)
    }
  },
  async mounted () {
    this.blList = (await getAllBusinessLayer())
    this.parentList = this.blList.filter(item => item.type !== BLTyp.Shop)
    this.parentInfo = this.blList.find(it => it.id === this.info.parentId)
    if (this.info?.childrenIds && this.info?.childrenIds.length > 0) {
      for (const item of this.blList) {
        if (this.info?.childrenIds.includes(item.id)) {
          this.childrenInfo.push(item.name)
        }
      }
    }
  },
  methods: {
    editParent () {
      this.editParentDialog = true
    },
    async submit (info) {
      const currentInfo = this.info
      currentInfo.parentId = info.parentId
      await updateBusinessLayerParent(currentInfo)
      this.editParentDialog = false
      this.$emit('reload')
    }
  }
}
</script>

<template>
  <div>
    <v-card
      :height="$vuetify.breakpoint.mobile ? 150 : 200"
      :width="$vuetify.breakpoint.mobile ? 150 : 200"
      class="pa-4"
      color="#eeeeee"
      elevation="0"
      @click="editParent"
    >
      <div class="d-flex flex-column">
        <div class="text-body-1 font-weight-bold">
          Organization
        </div>
        <div class="text-caption mt-4">
          上级组织
        </div>
        <div v-if="parentInfo">
          <div class="text-caption font-weight-bold">
            {{ parentInfo?.name }}
          </div>
        </div>
        <div
          v-else
          class="text-caption"
        >
          暂无上级组织
        </div>
        <div class="text-body-2 mt-4">
          下级组织
        </div>
        <div v-if="childrenInfo">
          <div class="text-caption font-weight-bold">
            {{ childrenInfo.join(',') }}
          </div>
        </div>
        <div
          v-else
          class="text-caption"
        >
          暂无下级组织
        </div>
      </div>
    </v-card>
    <v-dialog
      v-model="editParentDialog"
      max-width="600px"
    >
      <base-form
        :schema="schema"
        class="pa-4"
        @close="editParentDialog=false"
        @submit="submit"
      />
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
